module.exports = __webpack_public_path__ + "/f814091ff8a5061f932fe45c14da3849.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/logos/intuit_logo_@2x.png
 ** module id = 952
 ** module chunks = 0
 **/